<div class="massupdate-container" id="updateContainer">
  @if (arbetsordrar.length > 0) {
    <div>
      <button type="button" class="close close-x" aria-label="Close" (click)="close()">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
      <rask-busy-spinner size="1"></rask-busy-spinner>
      {{ header }}: Uppdaterar {{ uppdateradeArbetsordrar.length }} av {{ arbetsordrar.length }} arbetsordrar
    </div>
  }

  @if (arbetsordrar.length === 0) {
    <div>
      {{ header }}: Klar
    </div>
  }
</div>
